import Session from '@/utils/Session'
import Toast from '@/utils/toast'
export const user = {
  state: {
    user: {}
  },
  getters: {},
  mutations: {


  },
  actions: {

  }
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js